import { useGlobalDefaultShoppingAddress } from '@/features/account/services/Addresses/hooks'
import { CaretDownIcon } from '@shipt/design-system-icons'
import styled from 'styled-components'
import { trackElementClicked } from '@/features/shared/analytics/element'
import { useIsGuestUser } from '@/features/account/services/User/hooks'
import { TextButton } from '@shipt/design-system-buttons'
import { useHandleDialog } from '@/features/shared/state/Dialog/useHandleDialog'
import { DynamicGlobalAddressModal } from '@/features/account/components/Modal/GlobalAddressModal/DynamicGlobalAddressModal'
import { DynamicGuestAddressModal } from '@/features/account/components/Modal/GuestAddressModal/DynamicGuestAddressModal'
import { Body } from '@shipt/design-system-typography'
import { Row } from '@shipt/design-system-layouts'
import { useZip } from '@/features/account/services/Zip/hooks'

export const MobileAddressButton = ({ $holidayGHP }: { $holidayGHP?: boolean }) => {
  const { openDialog } = useHandleDialog()
  const isGuestUser = useIsGuestUser()
  const shoppingAddress = useGlobalDefaultShoppingAddress()
  const zip = useZip()

  const handleOnClick = () => {
    trackElementClicked({
      type: 'button',
      content: 'select_delivery_address',
      display_format: 'horizontal_list',
    })

    if (isGuestUser) {
      return openDialog(DynamicGuestAddressModal)
    }
    openDialog(DynamicGlobalAddressModal)
  }

  return (
    <AddressButtonWrapper align="center" spacing="xs" $holidayGHP={$holidayGHP}>
      <AddressText size="md" $holidayGHP={$holidayGHP}>
        Deliver to
      </AddressText>
      <TextButton onClick={handleOnClick} trailingIcon={CaretDownIcon} aria-label="Change address">
        <AddressText as="span" size="md" isPII $holidayGHP={$holidayGHP}>
          {shoppingAddress.street1 || zip}
        </AddressText>
      </TextButton>
    </AddressButtonWrapper>
  )
}

const AddressButtonWrapper = styled(Row)<{ $holidayGHP?: boolean }>`
  color: ${({ theme, $holidayGHP }) =>
    $holidayGHP && theme.color.content.base.neutral.primary_inverse};

  button {
    all: unset;
    text-decoration: underline;
    display: flex;
  }
`

const AddressText = styled(Body)<{ $holidayGHP?: boolean }>`
  color: ${({ theme, $holidayGHP }) =>
    $holidayGHP && theme.color.content.base.neutral.primary_inverse};
`
